var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiBedIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 10,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M1.5 5h9V3.5H12v6h-1.5V8h-9v1.5H0v-9h1.5V5Zm2.341-2.341A2.25 2.25 0 0 0 2.25 2v2.25H4.5a2.25 2.25 0 0 0-.659-1.591Z",
  clipRule: "evenodd"
})));
export default SvgHaidiBedIcon;